(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshFeatured(root) {
      var grid = root.querySelector('.msh-featured__grid');
      var setMid = root.querySelector('.msh-featured__set--mid');
      var prev = root.querySelector('.msh-featured__nav--prev');
      var next = root.querySelector('.msh-featured__nav--next');
      if (!grid || !setMid || !prev || !next) return;

      // Measured once at init: all three duplicated sets are identical width,
      // so this value is stable and only used for the initial scroll position
      // and the wrap-around boundary check.
      var setWidth = setMid.getBoundingClientRect().width + 20; // + gap between sets

      grid.scrollLeft = setWidth; // start on the middle (real) set, room to go either way

      // Measured fresh on every click, never cached: caching this at load time
      // previously caused a bug where layout hadn't settled yet, producing a
      // near-zero card width and near-zero movement per click.
      function getCardPitch() {
        return setMid.querySelector('.msh-fcard').getBoundingClientRect().width + 16;
      }

      var animating = false;
      function animateBy(delta) {
        if (animating) return;
        animating = true;
        var start = grid.scrollLeft;
        var target = start + delta;
        var duration = 380;
        var startTime = null;
        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }
        function step(timestamp) {
          if (startTime === null) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          grid.scrollLeft = start + (target - start) * easeOutCubic(progress);
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            if (grid.scrollLeft >= setWidth * 2) {
              grid.scrollLeft -= setWidth;
            } else if (grid.scrollLeft <= 0) {
              grid.scrollLeft += setWidth;
            }
            animating = false;
          }
        }
        window.requestAnimationFrame(step);
      }

      next.addEventListener('click', function () {
        animateBy(getCardPitch());
      });
      prev.addEventListener('click', function () {
        animateBy(-getCardPitch());
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-featured').forEach(initMshFeatured);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshRecentlyViewed(root) {
      var row = root.querySelector('.msh-recently-viewed__row');
      var next = root.querySelector('.msh-recently-viewed__next');
      if (!row || !next) return;

      function updateVisibility() {
        var hasOverflow = row.scrollWidth > row.clientWidth + 4;
        next.classList.toggle('visible', hasOverflow);
      }

      next.addEventListener('click', function () {
        row.scrollBy({ left: 300, behavior: 'smooth' });
      });

      window.addEventListener('resize', updateVisibility);
      window.addEventListener('load', updateVisibility);
      updateVisibility();
    }

    function initAll() {
      document.querySelectorAll('.msh-recently-viewed').forEach(initMshRecentlyViewed);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-recommended"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshRecommended(root) {
      var row = root.querySelector('.msh-recommended__row');
      var setReal = root.querySelector('.msh-recommended__set--real');
      if (!row || !setReal) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      var scrollPos = row.scrollLeft; // tracked separately — browsers round scrollLeft
                                       // to whole pixels, so sub-pixel increments read
                                       // back from row.scrollLeft directly get silently
                                       // dropped every frame and nothing ever moves
      var paused = false;

      row.addEventListener('click', function (e) {
        if (e.target.closest('a')) return; // let product links navigate, don't toggle pause
        paused = !paused;
      });

      function roll() {
        if (!setReal.isConnected) return;

        if (paused) {
          scrollPos = row.scrollLeft; // stay in sync if paused mid-frame
        } else {
          // if the visitor manually dragged/swiped the row, resync instead of
          // snapping back to the old trajectory and fighting their gesture
          if (Math.abs(row.scrollLeft - scrollPos) > 2) {
            scrollPos = row.scrollLeft;
          }
          var setWidth = setReal.getBoundingClientRect().width + 26; // + gap between sets
          if (setWidth > 0) {
            scrollPos += 0.333;
            if (scrollPos >= setWidth) {
              scrollPos -= setWidth;
            } else if (scrollPos < 0) {
              scrollPos += setWidth;
            }
            row.scrollLeft = scrollPos;
          }
        }
        window.requestAnimationFrame(roll);
      }
      window.requestAnimationFrame(roll);
    }

    function initAll() {
      document.querySelectorAll('.msh-recommended').forEach(initMshRecommended);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshReviews(root) {
      var row = root.querySelector('.msh-reviews__row');
      var setMid = root.querySelector('.msh-reviews__set--mid');
      var prev = root.querySelector('.msh-reviews__nav--prev');
      var next = root.querySelector('.msh-reviews__nav--next');
      if (!row || !setMid || !prev || !next) return;

      // Measured once at init: all three duplicated sets are identical width,
      // so this value is stable and only used for the initial scroll position
      // and the wrap-around boundary check.
      var setWidth = setMid.getBoundingClientRect().width + 20; // + gap between sets

      // Measured fresh on every click, never cached: caching this at load time
      // previously caused a bug where layout hadn't settled yet, producing a
      // near-zero card width and near-zero movement per click.
      function getCardPitch() {
        return setMid.querySelector('.msh-rcard').getBoundingClientRect().width + 16;
      }

      row.scrollLeft = setWidth; // start scrolled into the middle (real) set, room to go either way

      var animating = false;
      function animateBy(delta) {
        if (animating) return;
        animating = true;
        var start = row.scrollLeft;
        var target = start + delta;
        var duration = 380;
        var startTime = null;
        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }
        function step(timestamp) {
          if (startTime === null) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          row.scrollLeft = start + (target - start) * easeOutCubic(progress);
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            if (row.scrollLeft >= setWidth * 2) {
              row.scrollLeft -= setWidth;
            } else if (row.scrollLeft <= 0) {
              row.scrollLeft += setWidth;
            }
            animating = false;
          }
        }
        window.requestAnimationFrame(step);
      }

      next.addEventListener('click', function () {
        animateBy(getCardPitch());
      });
      prev.addEventListener('click', function () {
        animateBy(-getCardPitch());
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-reviews').forEach(initMshReviews);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rotator = document.getElementById('rotator');
    if (!rotator) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var lastY = window.scrollY;
    var rotation = 0;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      var delta = y - lastY;
      lastY = y;
      rotation += delta * 0.35;
      rotator.style.transform = 'rotate(' + rotation + 'deg)';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
